import Auth from '@/infrastructure/api/helper/Auth';
import download from '@/infrastructure/api/download';
import {納品加重明細出力条件型} from '@/type/custom/teishinkai/納品加重明細出力条件';

export default {
  async 集計ファイルをダウンロードする(出力条件: 納品加重明細出力条件型): Promise<void> {
    const auth = new Auth();
    const response = await auth.post('/api/custom/teishinkai/delivery-weighted-detail/download',
      出力条件,
      {
        responseType: 'blob',
      });
    const file = response.data;
    download.excelout(file, '納品加重明細表.xlsx');
  },
};
